import {
  stripeAmountToMajor,
  type Currency,
} from "@jammable/clientapi/src/payments";

export function getLocale() {
  return "en-US";
}

export function formatCurrency(amount: number, currency: Currency) {
  const formatter = new Intl.NumberFormat(getLocale(), {
    style: "currency",
    currency,
  });
  // `amount` is a Stripe minor-unit value; convert per currency (zero-decimal
  // currencies like JPY are already in the major unit). Intl then renders the
  // correct number of fraction digits for the currency automatically.
  return formatter.format(stripeAmountToMajor(amount, currency));
}

export function getCurrencySymbol(currency: Currency): string {
  return (0)
    .toLocaleString(getLocale(), {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}
